import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { statComparisonNavSelector } from '../../../../../../store/js/modules/statspro/stat-comparison/selectors';
import { UPDATE_NAV_ITEM } from '../../../../../../store/js/modules/statspro/stat-comparison/actions';
import { STATS_CATEGORY_ARRAY } from '../../../common/config/categories';

export const CategoryNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statComparisonNavSelector);

    return (
        <Select
            items={STATS_CATEGORY_ARRAY}
            initialSelectedItem={nav.category}
            activeItem={nav.category}
            label={getTranslation('label.statsLeaders.nav.category')}
            onSelectedItemChange={({ selectedItem }) => {
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'category',
                        value: selectedItem
                    })
                );
            }}
        />
    );
};
